import type { ReactNode } from 'react';

import { Navigate } from 'react-router';
import { useMsal } from '@azure/msal-react';

type RoleGuardProps = {
  role: 'sales' | 'servicing' | 'compliance'; // roles should match the Azure AD roles
  children: ReactNode;
};

function RoleGuard({ role, children }: RoleGuardProps) {
  const { accounts } = useMsal();
  const { idTokenClaims } = accounts[0];

  if (!idTokenClaims?.roles?.includes(role)) {
    return <Navigate replace to="/403" />;
  }

  return children;
}

export default RoleGuard;
